import { LocalStyles } from "@paperbits/common/styles";

export class SignupModel {
    public requireHipCaptcha: boolean;

    /**
     * Widget local styles.
     */
    public styles: LocalStyles = {};
}
